type RenderOptions = {
  proseSize?: string
  proseTheme?: string
  wrapperClasses?: string
}

export async function renderCode(code: string, options: RenderOptions = {}) {
  if (code === '') return ''

  const dark = document.body.classList.contains('dark')

  return fetch('/_uplandjs/render', {
    method: 'POST',
    body: JSON.stringify({
      html: code,
      bodyClasses: `prose prose-${options.proseSize} prose-${options.proseTheme} ${options.wrapperClasses} p-2 sm:p-4`,
      dark: dark ? 1 : 0
    }),
    headers: {
      'Content-Type': 'application/json',
      // @ts-ignore
      'x-widgets': Array.from(WidgetElement.widgets)?.join(',') ?? ''
    }
  }).then((res) => res.text())
}
